/**
 * Reading the csrf_token cookie — the server deliberately sets it NOT
 * HttpOnly so the SPA can re-read it after a full page reload (contract
 * csrf.ts). The response body's `csrf_token` field is the authoritative
 * channel; the cookie is only a seed source for page-reload continuity.
 */
import { CSRF_COOKIE_NAME } from '@web-v4/api-contract/v1/auth';
/**
 * Extracts the csrf_token cookie value, or undefined when absent.
 *
 * @param cookieString explicit cookie header (tests / non-browser);
 *                     defaults to `document.cookie` when available.
 * The value is returned verbatim (no decoding): Go writes the signed
 * token with cookie-safe characters only, and the contract states the
 * cookie value is identical to the bootstrap body's `csrf_token`.
 */
export function readCsrfCookie(cookieString) {
    const source = cookieString ?? (typeof document !== 'undefined' ? document.cookie : '');
    if (source === '') {
        return undefined;
    }
    for (const part of source.split(';')) {
        const eq = part.indexOf('=');
        if (eq === -1) {
            continue;
        }
        if (part.slice(0, eq).trim() === CSRF_COOKIE_NAME) {
            const value = part.slice(eq + 1).trim();
            return value === '' ? undefined : value;
        }
    }
    return undefined;
}
//# sourceMappingURL=cookie.js.map